import React, { useState } from "react";
import styled from "styled-components";
import InputField from "./core-components/InputField.tsx";
import Button from "./core-components/Button.tsx";
import { ToastContainer, toast } from "react-toastify";

import { orderTaxes, orderTaxesNames } from "../../utils/constants.ts";
import { createOrderInvoice } from "../../services/orderService.js";

import { useAuth } from "../../hooks/useAuth.jsx";
import SimpleDropdown from "./core-components/SimpleDropdown.tsx";
import Table from "./core-components/Table.tsx";
import { FaPlusCircle } from "react-icons/fa";
import InvoiceComponent from "./InvoiceComponent.tsx";

const FormRow = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  gap: 8px;

  align-self: center;
  margin-bottom: 8px;
`;
const FormContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 16px;

  align-self: center;
  margin-bottom: 8px;
`;
const ManualInvoice: React.FC = () => {
  const { token } = useAuth();
  const [lastName, setLastName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [city, setCity] = useState("");
  const [county, setCounty] = useState("");
  const [street, setStreet] = useState("");
  const [shippingOption, setShippingOption] = useState(
    orderTaxesNames.shipping
  );
  const [paymentOption, setPaymentOption] = useState(orderTaxesNames.card);
  const [orderDetails, setOrderDetails] = useState<
    {
      name: string;
      productCantity: number;
      salePrice: number;
      total: number;
    }[]
  >([]);
  const [name, setName] = useState("");
  const [quantity, setQuantity] = useState("");
  const [price, setPrice] = useState("");

  const [displayInvoice, setDisplayInvoice] = useState({});

  const handleInvoiceSave = async () => {
    if (
      !lastName ||
      !firstName ||
      !city ||
      !county ||
      !street ||
      !shippingOption ||
      !paymentOption ||
      orderDetails.length === 0
    ) {
      toast.error("Completează toate câmpurile!", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    try {
      const invoice: {
        invoiceID: string;
        invoiceDate: string;
      } = await createOrderInvoice(0, token);

      const order = {
        lastName,
        firstName,
        city,
        county,
        street,
        shippingOption,
        paymentOption,
        orderDetails,
        invoice: {
          invoiceID: invoice.invoiceID,
          invoiceDate: invoice.invoiceDate,
        },
        totalPrice:
          orderDetails.reduce(
            (acc, item) =>
              acc + Number(item.salePrice) * Number(item.productCantity),
            0
          ) +
          (shippingOption === orderTaxesNames.shipping
            ? orderTaxes.shipping
            : 0) +
          (paymentOption === orderTaxesNames.cash ? orderTaxes.cash : 0),
      };
      setDisplayInvoice(order);
    } catch (error) {
      notifyErr();
      console.error("Error creating invoice:", error);
    }
  };

  const addProduct = async () => {
    if (name && quantity && price) {
      const newProduct = {
        productName: name,
        productCantity: Number(quantity),
        salePrice: Number(price),
      };
      setOrderDetails((prev) => [...prev, newProduct]);
      setName("");
      setQuantity("");
      setPrice("");
    } else {
      toast.error("Completează toate câmpurile pentru produs!", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "light",
      });
    }
  };
  const notify = () =>
    toast.success("Factură trimisă către client !", {
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
      theme: "light",
    });

  const notifyErr = () =>
    toast.error("Factura nu s-a putut trimite. Incearcă mai târziu !", {
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
      theme: "light",
    });

  if (displayInvoice && Object.keys(displayInvoice).length > 0)
    return <InvoiceComponent order={displayInvoice} token={token} isManual />;
  return (
    <FormContainer>
      <FormRow>
        <InputField
          name="lastName"
          type="text"
          label={"Nume"}
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
          placeholder={"Nume"}
          isRequired
        />
        <InputField
          name="firstName"
          type="text"
          label={"Prenume"}
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
          placeholder={"Prenume"}
          isRequired
        />
      </FormRow>
      <FormRow>
        <InputField
          name="county"
          type="text"
          label={"Județ"}
          value={county}
          onChange={(e) => setCounty(e.target.value)}
          placeholder={"Județ"}
          isRequired
        />
        <InputField
          name="city"
          type="text"
          label={"Oraș"}
          value={city}
          onChange={(e) => setCity(e.target.value)}
          placeholder={"Oraș"}
          isRequired
        />

        <InputField
          name="street"
          type="text"
          label={"Adresa"}
          value={street}
          onChange={(e) => setStreet(e.target.value)}
          placeholder={"Adresa"}
          isRequired
        />
      </FormRow>
      <FormRow>
        <SimpleDropdown
          values={[
            {
              value: orderTaxesNames.shipping,
              label: "Livrare",
            },
            {
              value: orderTaxesNames.pickUp,
              label: "Ridicare personală",
            },
          ]}
          name="shippingOption"
          label={"Opțiune livrare"}
          onChange={({ value, label }) => setShippingOption(value)}
        />
        <SimpleDropdown
          values={[
            {
              value: orderTaxesNames.card,
              label: "Card",
            },
            {
              value: orderTaxesNames.cash,
              label: "Cash",
            },
            {
              value: orderTaxesNames.transfer,
              label: "Transfer bancar",
            },
          ]}
          name="paymentOption"
          label={"Opțiune livrare"}
          onChange={({ value, label }) => setPaymentOption(value)}
        />
      </FormRow>
      <FormRow style={{ borderTop: "1px solid #eff1ed", paddingTop: "8px" }}>
        <InputField
          name="name"
          type="text"
          label={"Produs"}
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder={"Produs"}
          isRequired
        />
        <InputField
          name="quantity"
          type="number"
          label={"Cantitate"}
          value={quantity}
          onChange={(e) => setQuantity(e.target.value)}
          placeholder={"Cantitate"}
          isRequired
        />
        <InputField
          name="price"
          type="number"
          label={"Preț"}
          value={price}
          onChange={(e) => setPrice(e.target.value)}
          placeholder={"Preț"}
          isRequired
        />
        <Button
          id="save-invoice"
          onClick={addProduct}
          icon={<FaPlusCircle />}
          backgroundColor={"white"}
          color="var(--primary-brown)"
        />
      </FormRow>
      <Table
        columns={[
          { title: "Denumire", key: "productName" },
          { title: "Quantity", key: "productCantity" },
          { title: "Pret/buc", key: "salePrice" },
          { title: "Total", key: "total" },
        ]}
        rows={
          orderDetails.length > 0
            ? orderDetails.map((order) => ({
                ...order,
                total: Number(order?.productCantity) * Number(order?.salePrice),
              }))
            : []
        }
        onRowClick={(row) => {}}
      />
      <Button
        id="save-invoice"
        onClick={handleInvoiceSave}
        text="Generează"
        backgroundColor={"var(--primary-brown)"}
        color="white"
      />
      <ToastContainer />
    </FormContainer>
  );
};

export default ManualInvoice;
